


















export default {
  props: {
    action: { type: Function },
    description: { type: String, required: true },
    title: { type: String, required: true },
    verb: { type: String, required: true },
  },
};
